<template>
    <form class="login" @submit.prevent="ParolaReset">
        <h4>{{$t('Giris.1')}}</h4>
        <div class="form-group" :class="{ 'is-invalid': hata.Parola }">
            <input class="form-control" v-model="user.Parola" type="password">
            <label class="form-label">{{$t('Giris.18')}}</label>
            <label class="error" v-if="hata.Parola">{{hata.Parola}}</label>
        </div>
        <div class="form-group" :class="{ 'is-invalid': hata.ParolaTekrar }">
            <input class="form-control" v-model="user.ParolaTekrar" type="password">
            <label class="form-label">{{$t('Giris.19')}}</label>
            <label class="error" v-if="hata.ParolaTekrar">{{hata.ParolaTekrar}}</label>
        </div>
        <div class="form-group">
            <router-link to="/giris" class="hesap text-mavi float-left">{{$t('Giris.2')}}</router-link>
            <button type="submit" class="btn btn-sari float-right"><i class="flaticon2-lock"></i> {{$t('Giris.20')}}
            </button>
        </div>
        <div class="clearfix"></div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                user: {
                    Parola: null,
                    ParolaTekrar: null,
                    SifirlamaKodu : this.$route.params.SifirlamaKodu
                },
                hata: {
                    Parola: null,
                    ParolaTekrar: null,
                },
            }
        },
        methods: {
            ParolaReset() {
                if (!this.user.Parola) this.hata.Parola = this.$t('Hata.2'); else this.hata.Parola = null;
                if (!this.user.ParolaTekrar) this.hata.ParolaTekrar = this.$t('Hata.7'); else this.hata.ParolaTekrar = null;
                if (this.user.Parola && this.user.ParolaTekrar && this.user.Parola != this.user.ParolaTekrar) this.hata.ParolaTekrar = this.$t('Hata.8'); else this.hata.ParolaTekrar = null;
                if (!this.hata.Parola && !this.hata.ParolaTekrar && this.user.Parola == this.user.ParolaTekrar) {

                    this.$store.dispatch("Login", {...this.user, path: 'giris/parola'})
                        .then(response => {
                            if (response.Durum == "OK") {

                                this.$message.success(response.Mesaj)

                            } else {
                                this.$message.error(response.Mesaj)
                                this.hata = response.Hata;

                            }

                        })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Giris/sifirla.vue